import type { CategorisableService } from '../service-category-groups';
import { groupServicesByCategory } from '../service-category-groups';

export interface CategorizedServiceListProps {
  services: readonly CategorisableService[];
}

export function CategorizedServiceList({
  services,
}: CategorizedServiceListProps) {
  const groups = groupServicesByCategory(services);

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {groups.map((group) => (
        <section key={group.categoryName} className="min-w-0">
          <h3 className="mb-1 text-sm font-semibold">{group.categoryName}</h3>
          <ul className="text-muted-foreground flex flex-col gap-1 text-sm">
            {group.services.map((service) => (
              <li key={service.name}>{service.name}</li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
